// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"355": "code_activation-CodeActivationModal","58": "code_activation-PhoneVerification",}[chunkId] + "." + {"355": "120a788c96c130a6","58": "fab48b7d07db7369",}[chunkId] + ".js"
}